import * as React from 'react';
import useProductName, { DEFAULT_PRODUCT_NAME } from 'brand-customization/useProductName';

import { Icon } from 'components/common';

const InternalDataLakeIcon = () => {
  const productName = useProductName();

  if (productName !== DEFAULT_PRODUCT_NAME) return <Icon name="database" />;

  return (
    <svg width="23" height="23" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
      <g clipPath="url(#clip0_2006_190)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.73096 13.9304C11.3263 13.9304 13.4304 11.8264 13.4304 9.23097C13.4304 6.63553 11.3263 4.5315 8.73096 4.5315C6.13564 4.5315 4.03149 6.63553 4.03149 9.23097C4.03149 11.8264 6.13564 13.9304 8.73096 13.9304ZM8.73096 16.356C12.6661 16.356 15.856 13.166 15.856 9.23097C15.856 5.29594 12.6661 2.10597 8.73096 2.10597C4.79583 2.10597 1.60596 5.29594 1.60596 9.23097C1.60596 13.166 4.79583 16.356 8.73096 16.356Z"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.08871 5.97131C9.12246 5.83251 9.29318 5.81404 9.35055 5.94294L10.5675 8.67588C10.5911 8.7291 10.6401 8.76281 10.6935 8.76281H11.6841C11.917 8.76281 12.106 8.97242 12.106 9.23097C12.106 9.48953 11.917 9.69914 11.6841 9.69914H10.1693C10.1158 9.69914 10.0669 9.66543 10.0433 9.61222L9.41749 8.20725L8.37321 12.4906C8.33946 12.6294 8.16874 12.6479 8.11136 12.519L6.89439 9.78606C6.87077 9.73285 6.82183 9.69914 6.7684 9.69914H5.77783C5.54496 9.69914 5.35596 9.48953 5.35596 9.23097C5.35596 8.97242 5.54496 8.76281 5.77783 8.76281H7.29264C7.34608 8.76281 7.39502 8.79651 7.41864 8.84973L8.04443 10.2547L9.08871 5.97131Z"
        />
      </g>
      <defs>
        <clipPath id="clip0_2006_190">
          <rect width="23" height="23" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InternalDataLakeIcon;
